import React from 'react'
import moment from 'moment';
import { Grid, GridItem } from 'components/Grid';
import InputMask from 'react-input-mask';
import { observer } from 'mobx-react'
import { SingleDatePicker } from 'react-dates';
import { HORIZONTAL_ORIENTATION } from 'react-dates/constants';
import Dropdown from 'components/Dropdown';
import PageLoader from 'components/PageLoader';
import { TermsField } from 'components/TermsField';
import './WidgetForm.scss';
import 'react-dates/lib/css/_datepicker.css';
import CustomFields from 'components/CustomFields';

@observer
class WidgetForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            modalTerms: false
        }
    }

    render() {
        const props = this.props;
        return (
            <div className="WidgetForm">
                <PageLoader
                    loading={props.loadingFormsFields}
                    styleLoaded={{
                        width: '100%'
                    }}
                >
                    <div className="header">
                        <div className="header-labels">
                            <div className="label"><span className="go-back" onClick={() => props.onGoBack()}>&#8810; Voltar</span></div>
                            <h4 className="label"><span className="icon icon-map-marker" />{props.adventure.title}</h4>
                            <h4 className="label"><span className="icon icon-calendar-full" />{moment(props.selectedDate).format('DD/MM/YYYY')}</h4>
                            <h4 className="label"><span className="icon icon-clock" />{props.selectedHour.value}</h4>
                        </div>
                    </div>
                    {props.children ?
                        props.children
                        :
                        <React.Fragment>
                            <h3>Insira seus Dados:</h3>
                            <p>Você não precisa pagar para fazer o agendamento</p>
                            <Grid style={{ width: '80%', margin: '5% auto 0' }}>
                                <CustomFields {...props} showLabel={true}>
                                    {(fields) =>
                                        fields.map((field, i) => (
                                            <GridItem key={i} lg={4} md={4} sm={4} xs={4}>
                                                {field}
                                            </GridItem>)
                                        )
                                    }
                                </CustomFields>
                            </Grid>
                            <TermsField
                                checked={props.termsChecked}
                                onChange={props.toggleTermsChecked}
                                terms={props.adventure.terms}
                                show={props.adventure.terms_on_request && !!props.adventure.terms}
                            />
                            <div className="concordo">
                                <input
                                    style={{ display: "inline-block" }}
                                    type="checkbox"
                                    checked={props.privacyChecked}
                                    onChange={props.togglePrivacyChecked}
                                /> Concordo com a <a className="link" href={props.privacyTerm} target="_blank" rel="noopener noreferrer">Política de privacidade de dados</a>
                            </div>
                        </React.Fragment>
                    }
                </PageLoader>
            </div>
        )
    }
}

export default WidgetForm
